const state = {
    status: "",
    namee: "",
    user: {
        id: null,
        name: "",
        email: "",
        password: "",
        type: ""
    },
    token: null,
    loading: false,
    isLoggedIn: false,
    showAlert: false,
    alertMsg: "",
    alertType: "",
    schedule: {
        username: "",
        date: [],
        title: "",
        description: "",
        location: "",
        theme: 0,
        ifNeeded: false,
        deadlineReply: false,
        deadlineDate: null,
        oneAns: false,
        contactInfo: false,
        hidSchedule: false,
        adminOnly: false,
        time: [],
        email: null,
        phone: null,
        ci0: null,
        ci1: null,
        ci2: null,
        ci3: null,
        ci4: null
    },
    e1: 1,
    link: "",
    getSchedule: {
        details: {},
        dates: [],
        participants: [],
        participantDates: []
    },
    baseURL: "http://localhost:8000/api/",
    email: ""
    /*admin:{
        id:null,
        name: "",
        email: "",
        type: 'admin'
    }*/
};

export default state;
